import { call, put, select, takeLatest } from "redux-saga/effects";
import request from "../../api/request";

function* getAllActiveSubCategoriesList(payload) {
  try {
    yield put({
      type: "GET_ALL_ACTIVE_SUB_CATEGORIES_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const params = new URLSearchParams();

    Object.entries(payload?.value || {}).forEach(([key, value]) => {
      params.append(key, String(value));
    })

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories-all?${params.toString()}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "GET_ALL_ACTIVE_SUB_CATEGORIES_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load sub categories",
      },
    });
    yield put({
      type: "GET_ALL_ACTIVE_SUB_CATEGORIES_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getAllSubCategories(payload) {
  try {
    yield put({
      type: "FETCH_SUB_CATEGORIES_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories?page=${payload.value.page}&search=${payload.value.search}&offset=${payload.value.offset}${payload.value.isActive ? "&isActive=" + payload.value.isActive : ""}`;
    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_SUB_CATEGORIES_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load sub categories",
      },
    });
    yield put({
      type: "FETCH_SUB_CATEGORIES_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* createSubCategory(payload) {
  try {
    yield put({ type: "CREATE_SUB_CATEGORY_REQUESTING" });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories`;

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful save",
        message: response?.message || "Successful save subcategory",
      },
    });

    yield put({
      type: "CREATE_SUB_CATEGORY_SUCCESS",
      value: response.data,
    });

    const state = yield select();
    const lastParams = state.subCategoriesState.lastFetchParams;

    yield put({
      type: "FETCH_SUB_CATEGORIES_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Failed save subcategory",
      },
    });
    yield put({
      type: "CREATE_SUB_CATEGORY_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* getSubCategoryById(payload) {
  try {
    yield put({
      type: "READ_SUB_CATEGORY_REQUESTING",
    });
    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "READ_SUB_CATEGORY_SUCCESS",
      value: response.data,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "READ_SUB_CATEGORY_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* updateSubCategory(payload) {
  try {
    yield put({
      type: "UPDATE_SUB_CATEGORY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories/${payload.value.id}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful update",
        message: response?.message || "Successful update subcategory",
      },
    });

    yield put({
      type: "UPDATE_SUB_CATEGORY_SUCCESS",
      value: response.data,
    });

    const state = yield select();
    const lastParams = state.subCategoriesState.lastFetchParams;

    yield put({
      type: "FETCH_SUB_CATEGORIES_REQUEST",
      value: lastParams,
    });

  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Failed save subcategory",
      },
    });
    yield put({
      type: "UPDATE_SUB_CATEGORY_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* changeStateSubCategory(payload) {
  try {
    yield put({
      type: "CHANGE_STATE_SUB_CATEGORY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/subCategories/change-status/${payload.value.id}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful change state",
        message: response?.message || "Successful change state subcategory",
      },
    });

    yield put({
      type: "CHANGE_STATE_SUB_CATEGORY_SUCCESS",
      value: response.data,
    });

    const state = yield select();
    const lastParams = state.subCategoriesState.lastFetchParams;

    yield put({
      type: "FETCH_SUB_CATEGORIES_REQUEST",
      value: lastParams,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: error?.data?.message || "Failed save subcategory",
      },
    });
    yield put({
      type: "CHANGE_STATE_SUB_CATEGORY_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

export function* watchSubCategories() {
  yield takeLatest("FETCH_SUB_CATEGORIES_REQUEST", getAllSubCategories);
  yield takeLatest("CREATE_SUB_CATEGORY_REQUEST", createSubCategory);
  yield takeLatest("READ_SUB_CATEGORY_REQUEST", getSubCategoryById);
  yield takeLatest("UPDATE_SUB_CATEGORY_REQUEST", updateSubCategory);
  yield takeLatest("CHANGE_STATE_SUB_CATEGORY_REQUEST", changeStateSubCategory);
  yield takeLatest("GET_ALL_ACTIVE_SUB_CATEGORIES_REQUEST", getAllActiveSubCategoriesList);
}
